import { useEffect, useState } from 'react'
import { StateCase } from '../../config/enums'
import { getCompanySelected } from '../../utilities/controlStorage'
import { formPurchaseReceipt, reqPurchase } from '../PurchaseReceipt/storage'
import { controlList, reqStowage, reqWarehouse, storagePage } from './storage'
import useStorage from '../../hooks/useStorage'

export default function useInitial() {
    const [state, setState] = useState(StateCase.LOADING)
    const { currencies } = useStorage()

    useEffect(() => {
        controlList.filter.changeParams('sort', 'reception_code')
        controlList.filter.changeParams('order', 'desc')
        const company = getCompanySelected()

        const option = {
            value: company.id.toString(),
            label: company.name,
            image: company.country.image_url,
            span: company.local_currency.symbol
        }

        storagePage.company_enabled = company.is_enabled
        storagePage.timezone = company.timezone
        storagePage.currency =
            company.local_currency || currencies.find(c => c.id === 1)
        formPurchaseReceipt.setValue('company', option)
        controlList.filter.setOption('company_id', option)
        reqWarehouse.setQuery('company_id', option.value)
        reqStowage.setQuery('company_id', option.value)

        controlList.done().then(result => {
            if (result) {
                setState(StateCase.SUCCESS)
            } else {
                setState(StateCase.ERROR)
            }
        })

        return () => {
            storagePage.reception = null
            storagePage.currency = null
            reqPurchase.init()
            reqWarehouse.init()
            reqStowage.init()
        }
    }, [])

    return { state }
}
